/**
 * @generated SignedSource<<efc650c0056d481ece7c43419cb3a02b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineEditMainOrgTopicListItem_topics$data = ReadonlyArray<{
  readonly __typename: "OrgTopic";
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainOrgTopicListItemSelector_topics">;
  readonly " $fragmentType": "RoutineEditMainOrgTopicListItem_topics";
}>;
export type RoutineEditMainOrgTopicListItem_topics$key = ReadonlyArray<{
  readonly " $data"?: RoutineEditMainOrgTopicListItem_topics$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainOrgTopicListItem_topics">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RoutineEditMainOrgTopicListItem_topics",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineEditMainOrgTopicListItemSelector_topics"
    }
  ],
  "type": "OrgTopic",
  "abstractKey": null
};

(node as any).hash = "0e5a589435fc9539829ad97adce57753";

export default node;
